import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useCmsAuth } from '../contexts/CmsAuthContext';

interface CmsProtectedRouteProps {
  children: React.ReactNode;
  // Allowed roles kept for backward compatibility but ignored
  allowedRoles?: string[];
}

const CmsProtectedRoute: React.FC<CmsProtectedRouteProps> = ({ 
  children, 
  allowedRoles // ignored since we removed user management
}) => {
  const { isLoading, isAuthenticated } = useCmsAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading CMS...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/cms/login" state={{ from: location }} replace />;
  }

  // All authenticated users can access all CMS functionality now
  return <>{children}</>;
};

export default CmsProtectedRoute;